export const subtract = (x, y) => Number(x) - Number(y)
